<nb-action class="close-dialog" icon="close-outline" (click)="closeAction()"></nb-action>
<nb-card>
  <nb-card-header>Rechercher un éleveur</nb-card-header>
  <nb-card-body>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label>Nom de l'éleveur</label>
          <nb-form-field>
            <input type="text" fullWidth nbInput (keyup.enter)="searchAction()" [(ngModel)]="keyword">
            <button nbSuffix nbButton ghost (click)="searchAction()" title="Rechercher">
              <nb-icon icon="search-outline"></nb-icon>
            </button>
          </nb-form-field>
        </div>
      </div>
      @if (chooseCompany) {
        <div class="col-sm-12">
          <nb-list>
            <nb-list-item>
              <div class="content">{{ chooseCompany.name }}</div>
              <div class="action">
                <button nbButton (click)="chooseAction(null)" title="Retirer">
                  <nb-icon icon="close-outline" status="danger"></nb-icon>
                </button>
              </div>
            </nb-list-item>
          </nb-list>
        </div>
      }
      @if (!chooseCompany) {
        <div class="col-sm-12">
          <nb-list>
            @for (company of companies; track company) {
              <nb-list-item>
                <div class="content">{{ company.name }}</div>
                <div class="action">
                  <button nbButton (click)="chooseAction(company)" title="Choisir">
                    <nb-icon icon="checkmark-outline"></nb-icon>
                  </button>
                </div>
              </nb-list-item>
            }
          </nb-list>
        </div>
      }
    </div>
  </nb-card-body>
  <nb-card-footer>
    @if (errorText) {
      <p class="text-danger">{{ errorText }}</p>
    }
    <button nbButton fullWidth status="primary" shape="round" (click)="saveAction()" class="mb-2"
    [disabled]="!chooseCompany">Choisir</button>
  </nb-card-footer>
</nb-card>